import type {InterfaceStrings} from './strings'

// Brazilian Portuguese: the language's voice speaks pt-BR (data/voiceRoster.ts).
export const pt: InterfaceStrings = {
    nav: {
        beginSession: 'Começar',
        faq: 'Perguntas',
        pricing: 'Preços',
        legal: 'Aviso legal',
        signIn: 'Entrar',
        viewPricing: 'Ver preços',
        signOut: 'Sair',
        account: 'Conta',
        menu: 'Menu',
        closeMenu: 'Fechar menu',
        mainNav: 'Navegação principal',
        sessions: {one: '{n} sessão', other: '{n} sessões'},
    },
    footer: {
        selfHypnosisFor: 'Auto-hipnose para',
        anxiety: 'Ansiedade',
        sleep: 'Dormir',
        stress: 'Estresse',
        confidence: 'Autoconfiança',
        focus: 'Concentração',
        learn: 'Entender',
        ericksonian: 'O que é a hipnose ericksoniana',
        aiHow: 'Como funciona a hipnose com IA',
        vsMeditation: 'Hipnose ou meditação',
        methods: 'Práticas',
        languages: 'Idiomas',
    },
    page: {
        cta: 'Comece sua sessão grátis',
        hint: 'Sua primeira sessão é grátis',
        exploreFurther: 'Para ler mais',
        disclaimer:
            'Quies é uma ferramenta de bem-estar para relaxamento e autoconhecimento. Não é um dispositivo médico e não diagnostica, trata nem cura nenhuma condição. Se você estiver passando por uma crise de saúde mental, procure um profissional qualificado.',
        transcript: 'Transcrição',
        transcriptNote: 'Um trecho de uma sessão real do Quies, do jeito que foi falado.',
        breadcrumb: 'Trilha de navegação',
    },
    pricing: {
        selectPlan: 'Escolher este plano',
        subscribe: 'Assinar',
        perMonth: 'por mês',
        manageSubscription: 'Gerenciar assinatura',
        replayFree: 'Ouvir de novo uma sessão passada é sempre grátis.',
        offerLead: 'Cada sessão começa onde a anterior terminou.',
    },
    session: {
        chooseLanguage: 'Escolha seu idioma',
        changeLanguage: 'Mudar o idioma',
        changeVoice: 'Mudar a voz',
        previewVoice: 'Ouvir {voice}',
        stopPreview: 'Parar a amostra',
        continue: 'Continuar',
        composing: 'Quies está escrevendo sua sessão',
        preparing: 'Sua meditação está sendo preparada',
        pickingUp: 'retomando de onde você parou',
        today: 'Hoje',
        yesterday: 'Ontem',
        loading: 'Carregando…',
        showEarlier: 'Mostrar anteriores ({count})',
        tryDifferentApproach: 'Tentar outro caminho',
        nothingAdded: 'Nada acrescentado',
        purchaseConfirmed: 'Compra confirmada',
        firstSessionNote: 'Sua primeira sessão é gratuita. Você entrará na sua conta antes de ouvir.',
    },
    threshold: {
        title: 'Entre para ouvir',
        message: 'Sua primeira sessão é gratuita. Não precisa de cartão.',
        google: 'Continuar com o Google',
        sendLink: 'Enviar um link de acesso para mim',
        sending: 'Enviando…',
        emailLabel: 'Endereço de e-mail',
        or: 'ou',
        waitingTitle: 'Confira seu e-mail',
        waitingBody: 'Enviamos um link de acesso para {email}.',
        sendAgain: 'Enviar de novo',
        googleInstead: 'Entrar com o Google em vez disso',
        codeLabel: 'Ou digite o código de 6 dígitos do e-mail',
        codeSubmit: 'Continuar',
        codeSubmitting: 'Verificando…',
        codeWrong: 'Este código não está certo.',
        codeDead: 'Este código não funciona mais. Use o link do e-mail ou peça um novo.',
        errors: {
            invalidEmail: 'Digite um endereço de e-mail válido.',
            rateLimited: 'Muitas tentativas. Tente de novo em alguns minutos.',
            sessionError: 'Algo deu errado com seu acesso. Atualize a página e tente de novo.',
            sendFailed: 'Não foi possível enviar o e-mail. Tente de novo.',
            sessionExpired: 'Seu acesso expirou. Atualize a página e tente de novo.',
            generic: 'Algo deu errado. Tente de novo.',
        },
    },
    player: {
        play: 'Reproduzir',
        pause: 'Pausar',
        playAgain: 'Ouvir de novo',
        seek: 'Posição',
        eyesClosed: 'Olhos fechados',
        openEyes: 'Abrir os olhos',
        paused: 'Pausado',
        unavailable: 'Áudio indisponível',
        untitled: 'Sessão Quies',
    },
    failure: {
        turnFailed: 'Algo deu errado do nosso lado. Sua resposta foi guardada.',
        reconnecting: 'Reconectando…',
        refusalTitle: 'Vamos por outro caminho',
        refusal: 'Uma parte da sua mensagem não pôde ser respondida. Tente dizer de outro jeito, ou envie de novo.',
        openElsewhere: 'Esta sessão também está aberta em outra janela.',
        serviceDown: 'Não é possível acessar o Quies agora. Nada do que você fez foi perdido.',
        sessionsUsedTitle: 'Você já usou suas sessões',
        voiceFailedTitle: 'Sua meditação está escrita',
        voiceFailed: 'Não foi possível gerar a voz dela agora. Nada se perde, e narrar de novo não custa nada.',
        voiceStopped: 'A voz parou no meio do caminho. Ela pode continuar de onde parou.',
        streamMissing: 'Sua meditação está pronta, mas não chegou a esta página.',
        tapToListen: 'Toque para ouvir',
        fileFailed: 'Esta gravação não toca. A meditação pode ser narrada de novo, sem custo.',
        recordingGone: 'Esta gravação não está mais guardada.',
        purchaseCancelled: 'Compra cancelada. Nada foi cobrado.',
        purchasePending: 'Seu pagamento foi confirmado. Suas sessões estão demorando mais do que o normal para chegar.',
        checkoutFailed: 'Não foi possível concluir o pagamento. Nada foi cobrado.',
        sessionEnded: 'Esta sessão chegou ao fim.',
        busy: 'O Quies está com muita procura agora. Sua resposta foi guardada; tente de novo daqui a um minuto.',
        tooLong: 'Esta sessão ficou mais longa do que o Quies consegue comportar. Ela foi devolvida a você.',
        notSaved: 'Não foi possível salvar esta etapa. Tente de novo para continuar de onde parou.',
        meditationRefused:
            'Não foi possível escrever esta meditação do jeito pedido. Diga de outro jeito, ou comece de novo: esta sessão será devolvida a você.',
        meditationRefusedUncharged:
            'Não foi possível escrever esta meditação do jeito pedido. Diga de outro jeito, ou comece de novo.',
        linkExpired: 'Seu link de acesso expirou. Peça um novo.',
        oauthFailed: 'O acesso foi interrompido. Tente de novo.',
        offline: 'Você está sem conexão. Sua resposta será enviada assim que você voltar.',
        voiceChanged: 'Sua voz não está mais disponível; outra voz vai narrar esta meditação.',
        voiceReturned: 'Ainda não foi possível gerar a voz. Esta sessão foi devolvida a você.',
        voiceFailedAgain: 'Ainda não foi possível gerar a voz.',
        voiceResuming: 'A voz está voltando…',
        voiceLimited: 'Várias meditações já foram narradas para você nesta hora. Tente de novo um pouco mais tarde.',
        tryAgain: 'Tentar de novo',
        rephrase: 'Reformular',
        resume: 'Retomar',
        voiceAgain: 'Narrar de novo',
        listen: 'Ouvir',
        continue: 'Continuar',
        begin: 'Começar uma sessão',
        signIn: 'Entrar',
        checkAgain: 'Verificar de novo',
        sendLink: 'Enviar link mágico',
        useEmail: 'Usar e-mail',
    },
}
